import {Utils} from '@/services/utils/BasicUtils';
import { displayName } from '@/composables/useFilters';
import moment from 'moment';

export abstract class MandateContractUserDto {
  id!: number;
  pesel!: string;
  firstName!: string;
  lastName!: string;
  clientCount!: number;
  contractOfMandateStartsAt?: string;
}

export abstract class MandateContractListDto {
  quantity!: number;
  items!: MandateContractUserDto[];
  page!: number;
}

export class MandateContractUser extends MandateContractUserDto {
  constructor(dto?: MandateContractUserDto) {
    super();
    if (dto?.contractOfMandateStartsAt) {
      dto.contractOfMandateStartsAt = moment(dto.contractOfMandateStartsAt).calendar();
    }
    Utils.assign(this, dto);
  }

  get displayName(): string {
    return displayName(this);
  }
}

export class MandateContractList extends MandateContractListDto {
  constructor(dto?: MandateContractListDto) {
    super();
    dto!.items = dto!.items!.map(item => new MandateContractUser(item));
    Utils.assign(this, dto);
  }
}
